import { useEffect, useState } from "react";
import { ApiError, getJobById, Job } from "services";
import { useTenant } from "tenant";

export type JobState =
  | { status: "loading" }
  | { status: "not-found" }
  | { status: "error" }
  | { status: "ready"; job: Job };

/** Loads one public job of the current company. */
export function useJob(id: string | undefined): JobState {
  const { slug } = useTenant();
  const [state, setState] = useState<JobState>({ status: "loading" });

  useEffect(() => {
    if (!id) {
      setState({ status: "not-found" });
      return;
    }
    let cancelled = false;
    setState({ status: "loading" });
    getJobById(slug, id)
      .then((job) => !cancelled && setState({ status: "ready", job }))
      .catch((error) => {
        if (cancelled) return;
        setState({
          status:
            error instanceof ApiError && error.status === 404
              ? "not-found"
              : "error",
        });
      });
    return () => {
      cancelled = true;
    };
  }, [slug, id]);

  return state;
}
